import { Stack } from "@mui/material";
import { TextSkeleton } from "@src/appV2/redesign/system/ui-components";

export function DocumentsPageHeaderSkeleton() {
  return (
    <Stack spacing={3} alignItems="center">
      <TextSkeleton variant="h4" width="90%" />
      <TextSkeleton variant="body2" width="100%" />
    </Stack>
  );
}
